import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative'
  },
  BasicInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      width: 200,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        minHeight: 40,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiFormControl-root': {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  SubmitRow: {
    padding: theme.spacing(4, 0),
    textAlign: 'center'
  },
  AddAdminSubmit: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    border: 'none',
    padding: theme.spacing(1, 6),
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.7
    },
    '&:hover, &:focus': {
      opacity: 0.7
    }
  },
  switchControl: {
    display: 'flex',
    alignItems: 'center'
  }
}))
